import e from "axios";
const r = async (o, t) => {
  const { data: a } = await e.delete(
    `https://${o}.vtex.app/api/coupon/order`,
    {
      data: { orderFormId: t }
    }
  );
  return a;
};
export {
  r as removeCoupon
};
